import { RESOURCES } from "@/organisms/Form"
import { getOptionById } from "@/pages/GovernancePage/applications/policies/getDemoData"

import type { AiPolicyFormProps } from "./AiPolicyForm.types"

export const getRules = (
  record: AiPolicyFormProps["record"],
  type: "allow" | "notAllow"
) => {
  if (!record) return [{}]

  return record[type === "allow" ? "allowed" : "notAllowed"].map((value) => ({
    ...value,
    rules: [
      ...value.rules.map((rule) => ({
        ...rule,
        condition: rule.id,
        // Single-choice selects hold one value; records always store a list.
        value:
          getOptionById(rule.id)?.scope === "only" ? rule.value : rule.value[0]
      })),
      {}
    ]
  }))
}

export const getInitialState = (record: AiPolicyFormProps["record"]) => {
  if (!record)
    return {
      resources: RESOURCES.ALL,
      specific_resources: [{}]
    }

  return {
    name_details: record.policyName,
    description_details: record.policyDescription,
    allow: getRules(record, "allow"),
    notAllow: getRules(record, "notAllow")
  }
}
